import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { apiFetch } from '../utils/api';

function FeedbackRequestModal({ show, onHide }) {
  const [type, setType] = useState('Bug');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const resetState = () => {
    setType('Bug');
    setTitle('');
    setDescription('');
    setSubmitting(false);
    setError('');
    setSuccess('');
  };

  const handleClose = () => {
    resetState();
    if (onHide) onHide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    try {
      await apiFetch('createFeedbackRequest', {
        method: 'POST',
        body: JSON.stringify({
          type,
          title: title.trim(),
          description: description.trim(),
        }),
      });
      setSuccess('Thanks! Your feedback has been submitted.');
      // Close shortly after success
      setTimeout(() => {
        handleClose();
      }, 800);
    } catch (err) {
      setError(err.message || 'Failed to submit feedback');
    } finally {
      setSubmitting(false);
    }
  };

  const isValid = title.trim().length > 0 && description.trim().length > 0;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Report Bug / Make Suggestion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                id="feedback-type-bug"
                name="feedback-type"
                label="Bug"
                value="Bug"
                checked={type === 'Bug'}
                onChange={(e) => setType(e.target.value)}
              />
              <Form.Check
                inline
                type="radio"
                id="feedback-type-suggestion"
                name="feedback-type"
                label="Suggestion"
                value="Suggestion"
                checked={type === 'Suggestion'}
                onChange={(e) => setType(e.target.value)}
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-3" controlId="feedback-title">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Short summary"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              maxLength={200}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="feedback-description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Details, steps to reproduce, or your idea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={submitting}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={!isValid || submitting}>
            {submitting ? 'Submitting…' : 'Submit Feedback'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default FeedbackRequestModal;

